//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import md5 from 'js-md5'
// import store from '@/store'                    // 引入vuex数据

export default {
  name: 'register',
  data () {
    return {
      alertBol: false,
      isFirstStep: true,
      canGoNext: false,
      canResetPsd: false,
      phone: '',     // 手机号码
      password: '',  // 密码
      rePassword: '', // 重复密码
      canPush: false, // 是否通过校验
      verifTip: this.$t('flowLogin11'),
      canGetVerifCode: false, // 能否获取验证码
      timeInterval: 60,  // 验证码获取cd
      graphInfo: { // 图形验证信息
        graphCode: '',
        graphCodeKey: '',
        graphUrl: ''
      },
      inputGraphCode: '', // 用户输入的图形验证码
      smscode: '', // 短信验证码
      validateCode: '' // 短信验证码校验码
    }
  },
  mounted () {
    // this.$_message(12)
    this.getGraphCode()
  },
  methods: {
    // 验证空值
    validate (...params) {
      let temp = true
      params.forEach(element => {
        if (!element) {
          temp = false
        }
      })
      return temp
    },
    // formValidate (formItems) {
    //   let flag = false
    //   formItems.forEach(item => {
    //     let validate = item.validate && item.validate()
    //     flag = flag || validate
    //   })
    //   return flag
    // },
    close () {
      this.$emit('close')
    },
    btn () {
      if (!this.canGoNext) {
        return
      }
      let data = {
        'phone': this.phone,
        'smscode': this.smscode
      }
      this.$api.post('VALIDATE_SMSCODE', data, (res) => {
        // this.close()
        this.isFirstStep = false
        this.validateCode = res.data
      })
    },
    // 会跳到第一步
    backToFirstStep () {
      this.isFirstStep = true
    },
    // 获取验证码
    getVerifCode () {
      if (this.timeInterval < 60  || !this.canGetVerifCode) return
      this.verifTip = `${this.$t('flowLogin83')}${this.timeInterval}${this.$t('flowLogin12')}`
      this.canGetVerifCode = false
      let data = {
        'business': 2,
        'graphCodeKey': this.graphInfo.graphCodeKey,
        'graphcode': this.inputGraphCode,
        'phone': this.phone
      }
      this.$api.post('USER_GETSMSCODE', data, (res) => {
        if (res.code === 0) {
          let timer = setInterval(() => {
            if (this.timeInterval > 1) {
              this.timeInterval--
              this.verifTip = `${this.$t('flowLogin83')}${this.timeInterval}${this.$t('flowLogin12')}`
            } else {
              clearInterval(timer)
              this.timeInterval = 60
              this.canGetVerifCode = true
              this.verifTip = this.$t('flowLogin11')
            }
          }, 1000)
          if (this.phone.indexOf('@') > -1) {
            this.alertBol = true
          }
        } else {
          this.timeInterval = 60
          this.canGetVerifCode = true
          this.verifTip = this.$t('flowLogin11')
          this.getGraphCode()
        }
      }, () => {})
    },
    // 获取图形验证码
    getGraphCode () {
      this.$api.post('USER_GRAPHCODE', '', (res) => {
        this.graphInfo = {...res.data}
        this.inputGraphCode = ''
      })
    },
    // 重置密码
    setNewPassword () {
      if (!this.canResetPsd) return
      let data = {
        password: md5(this.password),
        phone: this.phone,
        validateCode: this.validateCode,
        rePassword: md5(this.rePassword)
      }
      this.$api.post('PSD_RECOVER', data, (res) => {
        this.$_message(this.$t('flowLogin23'))
        this.close()
      })
      console.warn('修改密码')
    }
  },
  watch: {
    phone (val) {
      this.canGetVerifCode = this.validate(this.phone, this.inputGraphCode)
      this.canGoNext = this.validate(this.phone, this.smscode)
    },
    inputGraphCode (val) {
      this.canGetVerifCode = this.validate(this.phone, this.inputGraphCode)
    },
    smscode () {
      this.canGoNext = this.validate(this.phone, this.smscode)
    },
    password () {
      this.canResetPsd = this.validate(this.password, this.rePassword)
    },
    rePassword () {
      this.canResetPsd = this.validate(this.password, this.rePassword)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugin/LeonSimpleLogin/src/forget-password.vue